import {
  ADD_CARDS,
  ADD_ONS,
  AddCards,
  AddOns,
  CANCEL_SUBSCRIPTION,
  CancelSubscription,
  CREATE_SUBSCRIPTION,
  CreateSubscription,
  DELETE_CARDS,
  DeleteCard,
  FREE_SUBSCRIPTION,
  FreeSubscription,
  GET_CARDS,
  GET_SUBSCRIPTION,
  GET_USER_BALANCE,
  GetSubscription,
  GetUserBalance,
  HttpRequest,
  PLUS_MINUTES,
  PlusMinutes,
  RequestMethod,
  UPDATE_CARDS,
  UPDATE_SUBSCRIPTION,
  UpdateCard,
  UpdateSubscription,
  UserCardsDeatils,
} from '@/api';
import { createAsyncThunk } from '@reduxjs/toolkit';

interface HttpResponse<T> {
  status: number;
  result: T;
  message: string;
  success: false;
}

export const buySubscription: any = createAsyncThunk(
  CREATE_SUBSCRIPTION,
  async (payload: any) => {
    try {
      const response = (await HttpRequest({
        url: CreateSubscription,
        method: RequestMethod.POST,
        body: payload,
      })) as HttpResponse<any>;

      return response;
    } catch (error) {
      throw error;
    }
  },
);

export const getSubscription: any = createAsyncThunk(
  GET_SUBSCRIPTION,
  async (payload: any) => {
    try {
      const response = (await HttpRequest({
        url: GetSubscription,
        method: RequestMethod.GET,
        body: payload,
      })) as HttpResponse<any>;

      return response;
    } catch (error) {
      throw error;
    }
  },
);

export const  cancelSubscription: any = createAsyncThunk(
  CANCEL_SUBSCRIPTION,
  async (payload: any) => {
    try {
      const response = (await HttpRequest({
        url: CancelSubscription,
        method: RequestMethod.POST,
        body: { data: payload },
      })) as HttpResponse<any>;

      return response;
    } catch (error) {
      throw error;
    }
  },
);

export const updateSubscription: any = createAsyncThunk(
  UPDATE_SUBSCRIPTION,
  async (payload: any) => {
    try {
      const response = (await HttpRequest({
        url: UpdateSubscription,
        method: RequestMethod.POST,
        body: { generalPracticeMinutesbalance: payload },
      })) as HttpResponse<any>;

      return response;
    } catch (error) {
      throw error;
    }
  },
);

export const createFreeSub: any = createAsyncThunk(
  FREE_SUBSCRIPTION,
  async (payload: any) => {
    try {
      const response = (await HttpRequest({
        url: FreeSubscription,
        method: RequestMethod.POST,
        body: payload,
      })) as HttpResponse<any>;

      return response;
    } catch (error) {
      throw error;
    }
  },
);

export const getUserCards: any = createAsyncThunk(
  GET_CARDS,
  async (payload: any) => {
    try {
      const response = (await HttpRequest({
        url: UserCardsDeatils,
        method: RequestMethod.GET,
        body: payload,
      })) as HttpResponse<any>;

      return response;
    } catch (error) {
      throw error;
    }
  },
);

export const addUserCards: any = createAsyncThunk(
  ADD_CARDS,
  async (payload: any) => {
    try {
      const response = (await HttpRequest({
        url: AddCards,
        method: RequestMethod.POST,
        body: payload,
      })) as HttpResponse<any>;

      return response;
    } catch (error) {
      throw error;
    }
  },
);

export const updateUserCards: any = createAsyncThunk(
  UPDATE_CARDS,
  async (payload: any) => {
    try {
      const response = (await HttpRequest({
        url: UpdateCard,
        method: RequestMethod.POST,
        body: payload,
      })) as HttpResponse<any>;

      return response;
    } catch (error) {
      throw error;
    }
  },
);

export const deleteUserCards: any = createAsyncThunk(
  DELETE_CARDS,
  async (payload: any) => {
    try {
      const response = (await HttpRequest({
        url: DeleteCard,
        method: RequestMethod.POST,
        body: payload,
      })) as HttpResponse<any>;

      return response;
    } catch (error) {
      throw error;
    }
  },
);

export const addExtraMinutes: any = createAsyncThunk(
  ADD_ONS,
  async (payload: any) => {
    try {
      const response = (await HttpRequest({
        url: AddOns,
        method: RequestMethod.POST,
        body: payload,
      })) as HttpResponse<any>;

      return response;
    } catch (error) {
      throw error;
    }
  },
);

export const plusExtraMInutes: any = createAsyncThunk(
  PLUS_MINUTES,
  async (payload: any) => {
    try {
      const response = (await HttpRequest({
        url: PlusMinutes,
        method: RequestMethod.POST,
        body: payload,
      })) as HttpResponse<any>;

      return response;
    } catch (error) {
      throw error;
    }
  },
);

export const getUserBalance = createAsyncThunk(
  GET_USER_BALANCE,
  async () => {
    try {
      const response = (await HttpRequest({
        url: GetUserBalance,
        method: RequestMethod.GET,
      })) as HttpResponse<any>;

      return response;
    } catch (error) {
      throw error;
    }
  },
);
